import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions } from 'redux-actions';
import { reduxKey } from '../constants';
import { setSocialLoginError, initializeFacebookJSSDK } from './actions';
const initialState = {};
const handler = handleActions({
    [`${setSocialLoginError}`]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            error: action.payload.errorCode
        }),
    [`${initializeFacebookJSSDK}`]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            isFacebookSDKInitialized: true
        })
}, initialState);
export default {
    [reduxKey]: handler
};
